export var CompareResult;
(function (CompareResult) {
    CompareResult[CompareResult["BEFORE"] = -1] = "BEFORE";
    CompareResult[CompareResult["EQUAL"] = 0] = "EQUAL";
    CompareResult[CompareResult["AFTER"] = 1] = "AFTER";
})(CompareResult || (CompareResult = {}));
export const chapter_verse_compare = (a, b) => {
    if (a.chapter < b.chapter) {
        return CompareResult.BEFORE;
    }
    else if (a.chapter > b.chapter) {
        return CompareResult.AFTER;
    }
    else {
        if (a.verse < b.verse) {
            return CompareResult.BEFORE;
        }
        else if (a.verse > b.verse) {
            return CompareResult.AFTER;
        }
        return CompareResult.EQUAL;
    }
};
export const chapter_verse_start = (sbc) => {
    return { chapter: sbc.chapter_start, verse: sbc.verse_start };
};
export const chapter_verse_end = (sbc) => {
    return { chapter: sbc.chapter_end, verse: sbc.verse_end };
};
